import ViewListIcon from '@material-ui/icons/ViewList';
import TrucksTraffic from './List/List';
import { TrucksCreate } from './Create/Create';
export const trucksTrafficResource = {
	list: TrucksTraffic,
	icon: ViewListIcon,
	create: TrucksCreate
}
